import moment from 'moment';

export const getMonthName = (key, format = 'MMM') => {
  const month = key.split('-')[1];
  return moment(parseInt(month, 10), 'M').format(format);
};
